module.exports = __webpack_public_path__ + "static/media/sub-bass.5aa79357.wav";